/* global jQuery COMPONENTS */

COMPONENTS.ComponentTeam = (function ($) {
  function ComponentTeam () {
    this.$component = $('[data-ecs-component="team"]')
    this.$teamGrid = $('[data-ecs-component="team-grid"]')
    this.$filterButtons = $('[data-ecs-components-team-category]')
    this.defaultCategory = $('[data-ecs-components-team-category-default]').data('ecs-components-team-category-default')
    this.gridOpts = {
      itemSelector: '[data-ecs-components-element="team-member"]',
      layoutMode: 'masonry',
      filter: this.defaultCategory
    }

    this.$accordion = $('[data-ecs-components-control="team-accordion"]')
    this.$accordionToggles = $('[data-ecs-accordion-control]')
  }

  ComponentTeam.prototype.calcCardHeights = function (grid) {
    if (typeof grid == 'undefined') {
      return;
    }

    const $teamCardItems = $(grid).find('[data-ecs-components-element="team-member"]')
    let tallestCardHeight = 0
    const viewportTablet = $(window).width() >= 769

    $teamCardItems.each(function () {
      const cardWrap = $(this).children('.ecs_component__card__wrap')
      cardWrap.css('min-height', '')
    })

    // Loop over the article cards to find the card with the greatest height
    $teamCardItems.each(function () {
      const cardWrap = $(this).children('.ecs_component__card__wrap')
      tallestCardHeight = Math.max(tallestCardHeight, cardWrap.outerHeight())
    })

    // Test if viewport is tablet or greater
    /*if (viewportTablet) { // Tablet or above
      $teamCardItems.each(function () {
        const cardWrap = $(this).children('.ecs_component__card__wrap')
        cardWrap.css('min-height', (tallestCardHeight + 'px'))
      })
    } else { // Mobile
      $teamCardItems.each(function () {
        const cardWrap = $(this).children('.ecs_component__card__wrap')
        cardWrap.css('min-height', '')
      })
    }*/

    $teamCardItems.each(function () {
      const cardWrap = $(this).children('.ecs_component__card__wrap')
      cardWrap.css('min-height', (tallestCardHeight + 'px'))
    })

    if ($(grid).length > 0) {
      $(grid).imagesLoaded(function () {
        $(grid).isotope('layout')
      })
    }

  }

  ComponentTeam.prototype.doFilter = function () {
    const component = this

    if (component.$teamGrid.length >= 1) {
      this.$teamGrid.imagesLoaded(function () {
        component.$teamGrid.isotope(component.gridOpts)
      })
    }
  }

  ComponentTeam.prototype.init = function () {
    const component = this

    component.$filterButtons.each(function () {
      const $button = jQuery(this)

      $button.click(function () {
        // Find the nearest parent wrapper
        const $wrapper = $button.closest('.ecs__component-wrapper')
        // Find filter buttons and grid within this wrapper
        const $localFilterButtons = $wrapper.find('[data-ecs-components-team-category]')
        const $localTeamGrid = $wrapper.find('[data-ecs-component="team-grid"]')

        // Remove active class from all buttons in this wrapper
        $localFilterButtons.each(function () {
          $(this).removeClass('ecs_active')
        })

        // Add active class to the clicked button
        $button.addClass('ecs_active')

        // Update filter option and filter only this grid
        const filterValue = $button.data('ecs-components-team-category')
        if ($localTeamGrid.length >= 1) {
          $localTeamGrid.imagesLoaded(function () {
            $localTeamGrid.isotope({ filter: filterValue })
          })
        }

      })
    })

    component.doFilter()

    if (component.$accordion.length >= 1) {
      // no accordion on page
      component.$accordion.accordion({
        exclusive: false,
        animateChildren: false
      })
    }

    if (component.$teamGrid.length >= 1) {
      this.$teamGrid.imagesLoaded(function () {
        // FIXME: There is a race condition happening here
        // I've added a setTimeout (500ms) to resolve, for now
        setTimeout(function () {
          component.calcCardHeights(component.$teamGrid)
        }, 500)
      })
    }

    $(component.$accordionToggles).each(function () {
      $(this).click(function () {
        const $needle = $(this).attr('data-ecs-accordion-control')
        $('.title[data-ecs-accordion="' + $needle + '"]').click()
      })
    })

    $(window).on('load', function () {
      component.doFilter()
      component.calcCardHeights(component.$teamGrid)
    })

    $(window).on('resize orientationchange', function () {
      // Recalc heights when the viewport size changes or the tablet is rotated
      component.doFilter()
      component.calcCardHeights(component.$teamGrid)
    })
  }

  return ComponentTeam
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentTeam = new COMPONENTS.ComponentTeam()
  COMPONENTS.componentTeam.init()
})
